<template>
  <div class="is-inline-flex">
    <o-icon icon="arrow-up-right-from-square" pack="fas" size="is-small" class="has-margin-right is-link" title="Open in New Tab" @click="handleOpenInTabClick"/>
    <o-tooltip :label="value" multiline>
        <div @click="handleClick" class="name-column is-link truncate">
            {{value}}
        </div>
    </o-tooltip>
  </div>
</template>

<script setup>

  import {toRefs} from "vue";

  const props = defineProps( {
    row: {
      required: true,
    },
    value: {
      required: true,
    },
  });
  const {
    row,
    value,
  } = toRefs(props);

  const emit = defineEmits([
    'click',
    'clickOpenInTab',
  ]);

  function handleClick() {
    emit('click', row.value);
  }

  function handleOpenInTabClick() {
    emit('clickOpenInTab', row.value);
  }

</script>

<style scoped lang="scss">
    .name-column {
      max-width: 200px;
    }
</style>